const DAY_MS = 24 * 60 * 60 * 1000;

const nairaFormatter = new Intl.NumberFormat('en-NG', { maximumFractionDigits: 0 });

/** ₦1,355,000 — whole naira, thousands separators, no currency-code noise. */
export function formatNaira(amount: number): string {
  const safe = Number.isFinite(amount) ? Math.round(amount) : 0;
  const sign = safe < 0 ? '-' : '';
  return `${sign}₦${nairaFormatter.format(Math.abs(safe))}`;
}

/** "20 Nov 2026" for an ISO date or timestamp; '' when unparseable. */
export function formatDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  return new Intl.DateTimeFormat('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  }).format(d);
}

/** YYYY-MM-DD in UTC — the snapshot's notion of "today". */
export function toIsoDay(date: Date): string {
  return date.toISOString().slice(0, 10);
}

/** Whole days from `fromIso` to `toIso` (both read as UTC calendar days). */
export function daysBetween(fromIso: string, toIso: string): number {
  const from = Date.parse(fromIso.slice(0, 10));
  const to = Date.parse(toIso.slice(0, 10));
  if (Number.isNaN(from) || Number.isNaN(to)) return 0;
  return Math.round((to - from) / DAY_MS);
}

export function plural(count: number, one: string, many = `${one}s`): string {
  return `${count} ${count === 1 ? one : many}`;
}

/** "a, b and c" */
export function joinList(items: string[]): string {
  if (items.length <= 1) return items.join('');
  return `${items.slice(0, -1).join(', ')} and ${items[items.length - 1]}`;
}

/** ₦1.36m / ₦450k / ₦900 — for small stat tiles. */
export function formatNairaCompact(amount: number): string {
  const abs = Math.abs(amount);
  if (abs >= 1_000_000) return `₦${(amount / 1_000_000).toFixed(abs >= 10_000_000 ? 1 : 2).replace(/\.?0+$/, '')}m`;
  if (abs >= 1_000) return `₦${Math.round(amount / 1_000)}k`;
  return formatNaira(amount);
}
